import axiosInstance from '../axiosInterceptor/axiosInstance'

const deleteUserFromOrg = async (data) => {
  const { orgId, userId } = data
  const url = `v1/orgs/${orgId}/users/${userId}`
  return axiosInstance.delete(url)
}

export default deleteUserFromOrg
